<template>
    <div class="progress" role="progressbar" aria-label="Progress Bar" :aria-valuenow="current" :aria-valuemin="minimum" :aria-valuemax="maximum">
        <div class="percent text-dark">
            {{ getText() }}
        </div>
        <div class="progress-bar progress-bar-striped progress-bar-animated text-bg-warning" :style="getStyle()"/>
    </div>
</template>

<style scoped lang="scss">
    .progress {
        position: relative;
        height:2rem;
        .percent {
            position: absolute;
            width: 100%;
            text-align: center;
            font-size: 1.4rem;
        }
    }
</style>

<script lang="ts">

import { defineComponent } from "vue";

export default defineComponent({
    props: {
        minimum: { type: Number, required: false, default: 0 },
        maximum: { type: Number, required: false, default: 100 },
        current: { type: Number, required: false, default: 0 },
    },
    methods: {
        getValue(): string {
            let w = "100";
            if (this.maximum)
                w = Math.round((this.current/this.maximum * 100)).toFixed(0);
            return w;
        },
        getStyle(): string {
            return `width: ${this.getValue()}%`;
        },
        getText(): string {
            return `${this.getValue()} %`;
        },
    },
    watch: {
        current(): void {
            this.$forceUpdate();
        },
    },
});

</script>
